<div class="distractor-section">
  <h2 *ngIf="headline" class="distractor-section__headline">{{ headline }}</h2>
  <div class="distractor-section-row">
    <div class="distractor-section-col-xxl-4" *ngIf="distractor">
      <hdi-distractor
        [circleSplash]="distractor.circleSplash"
        [circleText]="distractor.circleText"
        [link]="distractor.link"
        [viewport]="
          distractor.viewport ? distractor.viewport : ViewportType.desktop
        "
        [text]="distractor.text"
        [circleIcon]="distractor.circleIcon"
        [rotationDegrees]="distractor.rotationDegrees"
      ></hdi-distractor>
    </div>
    <div class="distractor-section-col-xxl-8" *ngIf="paragraph">
      <div class="distractor-section__paragraph">
        <p class="distractor-section__paragraph__top" *ngIf="paragraph.topText">
          {{ paragraph.topText }}
        </p>
        <p
          class="distractor-section__paragraph__bottom"
          *ngIf="paragraph.bottomText"
        >
          {{ paragraph.bottomText }}
        </p>
      </div>
    </div>
  </div>
  <div class="distractor-section__anchor" *ngIf="linkBox">
    <p class="distractor-section__anchor__text">{{ linkBox.linkText }}</p>
    <hdi-link
      class="distractor-section__anchor__link"
      [type]="linkBox.link.linkType ?? LinkType.NOSTYLES"
      [label]="linkBox.link.label | capitalize"
      [href]="linkBox.link.href ?? ''"
      [hrefType]="linkBox.link.hrefType ?? HrefType.ANGULAR_ROUTE"
    ></hdi-link>
  </div>
  <ul class="distractor-section__list">
    <li class="distractor-section__list__item" *ngFor="let item of list">
      <p>{{ item }}</p>
    </li>
  </ul>
  <hdi-expand *ngIf="expand" [label]="expand.label | capitalize"></hdi-expand>
</div>
